/**
 * PayPal Payment Script
 */

(function() {
    'use strict';

    const PAYMENT_MONITOR_PREFIX = '[PaymentMonitoring:PayPal] ';

    function logPaymentEvent(eventType, details) {
        const message = PAYMENT_MONITOR_PREFIX + eventType + ' | ' + JSON.stringify(details);
        console.warn(message);
    }

    function logApiFailure(apiName, status, error, details) {
        logPaymentEvent('API_FAILURE', {
            api: apiName,
            httpStatus: status,
            error: error,
            ...details
        });
    }

    window.paypalDelticoreMonitoring = {
        logPaymentEvent,
        logApiFailure
    };

})();

$(document).ready(function () {

    if (!window.paypal) {
        return;
    }

    // Detect if we're on the payment-change page
    const isPaymentChangePage = !!document.getElementById('paymentChangeForm');
    const orderToken = isPaymentChangePage ? document.getElementById('orderToken')?.value : null;

    // Configuration for payment-change page uses different endpoint
    const config = isPaymentChangePage
        ? {
            initChangePaymentUrl: '/delticore/payment/paypal/init-change-payment',
            successUrl: '/delticore/payment/callback/success/',
            failedUrl: '/delticore/payment/success/summary/'
        }
        : window.paypalDelticoreConfig;

    if (!config) {
        return;
    }

    let orderDOID = null;
    let token = null;

    paypal.Buttons({

        style: {
            label: 'pay'
        },

        onClick() {
            const container = document.getElementById('paypal-button-container');
            if (container) {
                container.style.pointerEvents = 'none';
                container.style.opacity = '0.5';
            }
        },

        async createOrder(data, actions) {
            // On payment-change page, we need to initialize the payment change flow
            if (isPaymentChangePage) {
                
                try {

                    var csrfToken = $("input[name='_csrf']").val();
                    
                    const fetchOptions = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'X-CSRF-TOKEN': csrfToken || ''
                        },
                        body: 'token=' + encodeURIComponent(orderToken),
                        credentials: 'same-origin'
                    };

                    const response = await fetch(config.initChangePaymentUrl, fetchOptions);
                    
                    if (!response.ok) {
                        if (window.paypalDelticoreMonitoring) {
                            window.paypalDelticoreMonitoring.logApiFailure('initChangePayment', response.status, 'HTTP Error', {
                                url: config.initChangePaymentUrl,
                                executionTimeMs: responseTime
                            });
                        }
                        throw new Error('Failed to initialize PayPal payment change');
                    }
                    
                    const responseData = await response.json();
                    orderDOID = responseData.orderDOId;
                    token = responseData.paypalToken;

                    // Return the PayPal token to redirect to PayPal
                    return token;
                    
                } catch (error) {
                    console.error('[PayPalDelticore] Payment change error:', error);
                    if (window.paypalDelticoreMonitoring) {
                        window.paypalDelticoreMonitoring.logPaymentEvent('INIT_CHANGE_PAYMENT_ERROR', {
                            error: error.message || String(error),
                            stack: error.stack
                        });
                    }
                    throw error;
                }
            }
            
            // Standard createOrder flow for regular checkout
            let url = config.createOrderUrl;
            const $refInput = $('input[name="referenceNumber"]');
            const ref = $refInput.val();
            if (ref) {
                url += '?' + new URLSearchParams({ refNum: ref }).toString();
            }

            try {
                const startTime = Date.now();
                const response = await fetch(url, {
                    method: 'GET',
                });
                const responseTime = Date.now() - startTime;

                if (!response.ok) {
                    if (window.paypalDelticoreMonitoring) {
                        window.paypalDelticoreMonitoring.logApiFailure('createOrder', response.status, 'HTTP Error', {
                            url: url,
                            executionTimeMs: responseTime
                        });
                    }
                    throw new Error('Failed to create PayPal order');
                }
                const data = await response.json();

                orderDOID = data.orderDOId;
                token = data.paypalToken;

                return token;
            } catch (error) {
                if (window.paypalDelticoreMonitoring) {
                    window.paypalDelticoreMonitoring.logPaymentEvent('CREATE_ORDER_ERROR', {
                        error: error.message || String(error)
                    });
                }
                throw error;
            }
        },

        onApprove(data) {
            // On payment-change page, redirect to success callback after PayPal approval
            if (isPaymentChangePage) {
                // After PayPal approval, redirect to the success callback to update payment status
                if (orderDOID) {
                    window.location.href = config.successUrl + '/' + orderDOID;
                } else {
                    console.error('[PayPalDelticore] onApprove - orderDOID is missing, cannot redirect to success');
                    // Fallback: redirect to payment change page
                    window.location.href = '/checkout/payment-change/' + orderToken;
                }
            } else {
                window.location.href = config.successUrl + '/' + orderDOID;
            }
        },

        onError(error) {
            if (window.paypalDelticoreMonitoring) {
                window.paypalDelticoreMonitoring.logPaymentEvent('PAYMENT_ERROR', {
                    error: error.message || String(error),
                    orderDOId: orderDOID,
                    isPaymentChangePage: isPaymentChangePage
                });
            }
            // On payment-change page, redirect to payment change page on error
            if (isPaymentChangePage) {
                window.location.href = '/checkout/payment-change/' + orderToken;
            } else {
                window.location.href = config.failedUrl + '/' + orderDOID;
            }
        },

        onCancel() {
            // On payment-change page, redirect back to payment change page on cancel
            if (isPaymentChangePage) {
                window.location.href = '/checkout/payment-change/' + orderToken;
            } else {
                window.location.href = config.failedUrl + '/' + orderDOID;
            }
        }
    }).render('#paypal-button-container');
});